import { render } from "./ClientCreate.vue?vue&type=template&id=5d82510a&scoped=true"
import script from "./ClientCreate.vue?vue&type=script&lang=js"
export * from "./ClientCreate.vue?vue&type=script&lang=js"

import "./ClientCreate.vue?vue&type=style&index=0&id=5d82510a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d82510a"]])

export default __exports__